import { render, staticRenderFns } from "./ColumnConfig.vue?vue&type=template&id=c9d6cbf2&scoped=true"
import script from "./ColumnConfig.vue?vue&type=script&lang=js"
export * from "./ColumnConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d6cbf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9d6cbf2')) {
      api.createRecord('c9d6cbf2', component.options)
    } else {
      api.reload('c9d6cbf2', component.options)
    }
    module.hot.accept("./ColumnConfig.vue?vue&type=template&id=c9d6cbf2&scoped=true", function () {
      api.rerender('c9d6cbf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/ColumnConfig.vue"
export default component.exports